module.exports = __webpack_public_path__ + "static/media/fiverr_logo.1725b584.png";